import _ from 'lodash';
import {
  getOrganization as getOrganizationApi,
  createOrganization as createOrganizationApi
} from 'common/services/organization.service';
import {
  fetchOrganizationSucceed,
  fetchOrganizationFailure,
  createOrganizationSucceed,
  createOrganizationFailure
} from '../actions';
import { fetchAndStoreNewRefreshAndAccessTokens } from 'common/services/token.service';
import * as TrackingService from 'common/services/tracking.service';
import { setRumOrganization } from 'common/services/rum.service';

export const getOrganization = () => async dispatch => {
  try {
    const organization = await getOrganizationApi();
    dispatch(fetchOrganizationSucceed(organization));
    return organization;
  } catch (e) {
    dispatch(fetchOrganizationFailure());
    return e;
  }
};

export const createOrganization = (body, account) => async dispatch => {
  try {
    const organization = await createOrganizationApi(body);
    await fetchAndStoreNewRefreshAndAccessTokens(organization.id, false);

    TrackingService.trackOrgProperties(account, organization);
    setRumOrganization(organization);

    dispatch(createOrganizationSucceed(organization));
    return organization;
  } catch (e) {
    dispatch(createOrganizationFailure());
    if (e.isAxiosError) {
      const ex = { error: null };

      switch (_.get(e, 'response.status', null)) {
        case 400:
          const description = _.get(e, 'response.data.description', []);
          const errorsMap = {
            'Duplicate Entry': 'DUPLICATE_ORGANIZATION_NAME',
            'Bad Name': 'BAD_ORGANIZATION_NAME'
          };
          const error = description.find(e => e.param === 'name');
          ex.error = error ? errorsMap[error.msg] : null;
          break;
        default:
          ex.error = 'GENERAL_ERROR';
      }

      throw ex;
    }

    return null;
  }
};
